import { isNaN } from 'lodash';

export const parseNumber = (value: any) => {
  const number = value ? parseInt(value, 10) : null;
  return isNaN(number) ? null : number;
};
